import React from 'react'

// The 7 "Judges have come from" logos from the old hacklab-website repo
// (src/assets/sponsors/*), plus 4 new partners. No card/background behind
// any logo, and real colors kept everywhere.
//
// Most of the old logos were already provided as white/light variants (the
// old site displayed them straight on its own dark hero), so they're fine
// as-is. `glow: true` marks the handful that are mostly dark/black art
// (checked via mean opaque-pixel color) and would otherwise disappear on
// our dark background — those get a soft white drop-shadow halo instead of
// an inverted color or a background box, so the logo's own ink color is
// still what you see, just outlined enough to read.
const PARTNERS=[
    {name: 'b4i', src: '/partners/b4i.png'},
    {name: 'Pi School', src: '/partners/pi-school.png'},
    {name: 'BCG X', src: '/partners/bcgx.png'},
    {name: 'Chapeau', src: '/partners/chapeau.png', glow: true},
    {name: 'SDA Bocconi', src: '/partners/sda-bocconi.png'},
    {name: 'Kyma', src: '/partners/kyma.svg'},
    {name: 'KH Holdings', src: '/partners/kh-holdings.png'},
    {name: 'Pillar', src: '/partners/pillar.png', glow: true},
    {name: 'Mille Farmacie', src: '/partners/mille-farmacie.png', glow: true},
    {name: 'Tundr', src: '/partners/tundr.png', glow: true},
    {name: 'Google', src: '/partners/google.webp'},
]

// Duplicated once so the track can loop seamlessly at -50%.
const LOOP=[...PARTNERS,...PARTNERS]

export default function PartnersBar() {
    return (
        <section className='overflow-hidden relative py-14 w-full bg-dark'>
            <div className='partners-track'>
                {LOOP.map((p,i) => (
                    <div key={p.name+i} className='flex flex-shrink-0 justify-center items-center h-8 lg:h-10'>
                        <img
                            src={p.src}
                            alt={p.name}
                            className={'object-contain max-h-full '+(p.glow? 'partner-logo-glow':'partner-logo-plain')}
                        />
                    </div>
                ))}
            </div>
            <div className='partners-edge partners-edge--left' />
            <div className='partners-edge partners-edge--right' />
        </section>
    )
}
